Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmptyTopicOptions = exports.getTopicOptions = exports.topicOptionsDutch = exports.topicOptionsEnglish = void 0;
exports.topicOptionsEnglish = {
  reverseOrder: 'Reversed order',
  hideIcon: 'Hide icon',
  hideMedia: 'Hide media',
  hideHeading: 'Hide heading',
  hideAbstract: 'Hide abstract',
  hideAction: 'Hide action',
  previewMode: 'Preview mode'
};
exports.topicOptionsDutch = {
  reverseOrder: 'Draai volgorde om',
  hideIcon: 'Verberg icoon',
  hideMedia: 'Verberg media',
  hideHeading: 'Verberg titel',
  hideAbstract: 'Verberg tekst',
  hideAction: 'Verberg actie',
  previewMode: 'Preview mode'
};

exports.getTopicOptions = function (params) {
  var optionsStringList = params.optionStrings || [];
  var locale = params.locale || 'en';
  var language = locale.split('-')[0];
  var translation;

  switch (language) {
    case 'en':
      translation = exports.topicOptionsEnglish;
      break;

    case 'nl':
      translation = exports.topicOptionsDutch;
      break;

    default:
      translation = exports.topicOptionsEnglish;
      break;
  }

  var result = {};
  Object.keys(translation).forEach(function (key) {
    var optionSet = optionsStringList.includes(translation[key]);
    result[key] = optionSet;
  });
  return result;
};

exports.getEmptyTopicOptions = function () {
  return {
    reverseOrder: false,
    hideIcon: false,
    hideMedia: false,
    hideHeading: false,
    hideAbstract: false,
    hideAction: false,
    previewMode: false
  };
};